import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AnswerRenderer from '../AnswerRenderer';
import './AnswerAttribute.scss';
import { getRequest } from '../../../requestUtils';
var AnswerAttribute = /*#__PURE__*/function (_Component) {
  function AnswerAttribute(props) {
    var _this;
    _classCallCheck(this, AnswerAttribute);
    _this = _callSuper(this, AnswerAttribute, [props]);
    _this.updateSingleAnswer = _this.updateSingleAnswer.bind(_this);
    return _this;
  }
  _inherits(AnswerAttribute, _Component);
  return _createClass(AnswerAttribute, [{
    key: "updateSingleAnswer",
    value: function updateSingleAnswer(answer) {
      var _this$props = this.props,
        questionableId = _this$props.questionableId,
        questionableType = _this$props.questionableType,
        updateCompletionPercentage = _this$props.updateCompletionPercentage,
        updateAnswers = _this$props.updateAnswers;
      if (!answer) return;
      getRequest("/question_answers/".concat(answer.id), {
        questionable_id: questionableId,
        questionable_type: questionableType
      }).then(function () {
        updateCompletionPercentage();
        updateAnswers();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        customClass = _this$props2.customClass,
        fullView = _this$props2.fullView,
        questionableId = _this$props2.questionableId,
        questionableType = _this$props2.questionableType,
        csrfToken = _this$props2.csrfToken,
        editMode = _this$props2.editMode,
        questionnaireName = _this$props2.questionnaireName,
        hideFooterButton = _this$props2.hideFooterButton,
        answer = _this$props2.answer,
        handleNewResume = _this$props2.handleNewResume;
      return /*#__PURE__*/React.createElement("div", {
        className: "answer-attribute ".concat(customClass)
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AnswerRenderer, {
        key: answer.id,
        answer: answer,
        editMode: editMode,
        csrfToken: csrfToken,
        questionnaireName: questionnaireName,
        questionableId: questionableId,
        questionableType: questionableType,
        fullView: fullView,
        closeModalCallback: this.updateSingleAnswer,
        hideFooterButton: hideFooterButton,
        editable: fullView,
        handleNewResume: handleNewResume
      })));
    }
  }]);
}(Component);
AnswerAttribute.propTypes = {
  customClass: PropTypes.string,
  answer: PropTypes.shape({}).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  fullView: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  editMode: PropTypes.bool,
  questionnaireName: PropTypes.string.isRequired,
  hideFooterButton: PropTypes.bool,
  updateCompletionPercentage: PropTypes.func,
  updateAnswers: PropTypes.func.isRequired,
  handleNewResume: PropTypes.func
};
AnswerAttribute.defaultProps = {
  customClass: '',
  fullView: true,
  editMode: false,
  hideFooterButton: false,
  updateCompletionPercentage: function updateCompletionPercentage() {},
  handleNewResume: function handleNewResume() {}
};
export default AnswerAttribute;